import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { QRCode } from "react-qrcode-logo";

import { Button } from "@mui/material";

//import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import CharityElement from "./CharityElement";

import ConfirmWidget from "./ConfirmWidget";

import "react-phone-number-input/style.css";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal_V";

let env = require("./../../../../env");

// props has activeStep
export default function CharityDonationContent({
  isNotMobile = false,
  selectedCharity,
  cancelFunc,
  setSelectedCharity,
  confirmCharity
}) {
  const {} = useContext(KioskContext);

  const { qrCode, getKioskTheme } = useContext(SocketIOContext);

  const kiosktheme = getKioskTheme();
  const kioskstyles = useKioskVerticalStyles();

  return (
    <>
      <div
        style={{
          ...kioskstyles.charities.selectInstruction,
          ...kioskstyles.charities.charityModalTextColor,
          marginTop: "5vh"
        }}
      >
        {/* <Translate value="application.theme.charitySelectCharityInstruction" /> */}
      </div>

      <div
        style={{
          //height: "inherit"
          //height: "45vh"
          height: "100%",
          marginTop: "6vh"
        }}
      >
        <ConfirmWidget
          hideConfirmDialog={() => {
            cancelFunc();
          }}
          isThisCorrectStyle={kioskstyles.charities.charityModalTextColor}
          next={() => {
            confirmCharity(selectedCharity);
          }}
          descText={translate("application.theme.telephoneConfirmText")}
          targetText={selectedCharity.Title}
        />
        <PrinterConnectionModal />
      </div>
    </>
  );
}
